import React from 'react';
import { _ProductDetail } from './Products';

interface Props {
  pDetailData: _ProductDetail;
}

export type Kind = 'printed' | 'digital' | null;

export function getKind(p: _ProductDetail): Kind {
  const params = (p.parameters || {}) as any;
  const formats = params.format || [];
  for (const f of formats) {
    const n = (f.name || '').toLowerCase();
    if (n.includes('tištěn')) return 'printed';
    if (n.includes('elektron') || n.includes('pdf')) return 'digital';
  }
  // fallback z názvu
  if (/tištěn/i.test(p.name || '')) return 'printed';
  return 'digital';
}

const ProductDetailFormat: React.FC<Props> = ({ pDetailData }) => {
  const kind = getKind(pDetailData);
  if (!kind) return null;

  if (kind === 'printed') {
    return (
      <div className="pd-format pd-format--printed" role="note">
        <div className="pd-format__icon" aria-hidden="true">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M6 9V2h12v7" /><path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2" />
            <rect x="6" y="14" width="12" height="8" rx="1" />
          </svg>
        </div>
        <div className="pd-format__text">
          <strong>Tištěný (papírový) střih</strong>
          <span>Pošleme balíkem do 1–3 dní</span>
        </div>
      </div>
    );
  }
  return (
    <div className="pd-format pd-format--digital" role="note">
      <div className="pd-format__icon" aria-hidden="true">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
          <polyline points="14 2 14 8 20 8" />
          <line x1="12" y1="18" x2="12" y2="12" /><polyline points="9 15 12 12 15 15" />
        </svg>
      </div>
      <div className="pd-format__text">
        <strong>Elektronický PDF střih</strong>
        <span>Stáhnete ihned po zaplacení</span>
      </div>
    </div>
  );
};

export default ProductDetailFormat;
